// extracted by mini-css-extract-plugin
export default {"topPanel":"TopPanel_topPanel__tI23H","container":"TopPanel_container__1hfoZ","currentPage":"TopPanel_currentPage__2oV8b"};